import React, { useContext } from 'react';
import * as styles from './index.module.less';
import { PricingContext } from '../provider';
import CommonBlok from '@/components/common-blok';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { GOODS_TYPE } from '@/modules/pricing/utils';
import CardHeader from './components/card-header';
import CardPrice from './components/card-price';
import CardSeatsDuration from './components/card-seats-duration';
import CardBtnContainer from './components/card-btn-container';
import CardPlanRight from './components/card-plan-right';
import CardTopTips from './components/card-top-tips';
import { PRICE_UNIT_LANG_MAP } from '../constants';
import { CENTS_TO_DOLLAR } from '@/modules/pricing/hooks';
import NP from 'number-precision';
import { numericPricingPageSeats } from '@/utils';

export const CLASS_MAP = {
  [GOODS_TYPE.FREE]: 'free',
  [GOODS_TYPE.PRO]: 'pro',
  [GOODS_TYPE.TEAM]: 'team',
  [GOODS_TYPE.TEAM_ENTERPRISE]: 'custom',
};

const PricingCardContainer = () => {
  const { planInfo, formInfo, lang, teamPlanUnitPriceInfo } = useContext(PricingContext);
  const { t } = useTranslation();

  return (
    <CommonBlok
      isNewLayout={lang === 'ja'}
      isNewEnLayout={lang === 'en'}
      className={styles.blok_class}
      paddingBottom="0"
    >
      <div className={styles.wrapper}>
        <div className={styles.cards_outer}>
          <div className={styles.card_wrapper}>
            {planInfo.map((item, index) => {
              const seats = numericPricingPageSeats(formInfo.seats);
              let priceDesc = t(item.priceDesc[formInfo.payType] || item.priceDesc);
              // 日文的Pro需要显示出总价
              if (item.type === GOODS_TYPE.PRO && lang === 'ja' && formInfo.payType === 'year') {
                priceDesc =
                  t('subscribe_team_yearly_total_price_official', {
                    price: '15,800',
                  }) +
                  (lang === 'ja' ? PRICE_UNIT_LANG_MAP[lang] : '') +
                  ' · ' +
                  priceDesc;
              }

              /**
               * 处理价格描述，team plan当选择年付的时候要计算总价
               */
              if (item.type === GOODS_TYPE.TEAM && formInfo.payType === 'year') {
                priceDesc =
                  t('subscribe_team_yearly_total_price_official', {
                    price:
                      (lang === 'en' ? '$' : '') +
                      NP.divide(teamPlanUnitPriceInfo.year.realPrice * seats, CENTS_TO_DOLLAR).toLocaleString(),
                  }) +
                  (lang === 'ja' ? PRICE_UNIT_LANG_MAP[lang] : '') +
                  ' · ' +
                  priceDesc;
              }

              /**
               * 处理价格描述，team enterprise plan 日文
               */
              if (item.type === GOODS_TYPE.TEAM_ENTERPRISE && lang === 'ja') {
                priceDesc = 'アカウント数に捉われない大規模導入専用';
              }

              /**
               * 组合权益信息
               */
              const rightList = item.interest.map((item) => {
                return {
                  new: item.newFeature,
                  beta: item.beta,
                  text: t(item.text),
                };
              });

              return (
                <div key={item.type} className={styles.card_container}>
                  <CardTopTips type={item.type} index={index} />
                  <CardHeader title={t(item.name)} desc={t(item.description)} index={index} type={item.type} />
                  <CardPrice
                    price={item.averagePrice[lang]?.[formInfo.payType]}
                    monthlyPrice={item.averagePrice[lang]?.month}
                    priceDesc={priceDesc}
                    index={index}
                    type={item.type}
                  />
                  <CardSeatsDuration
                    index={index}
                    seatsDesc={t(item.seats)}
                    durationDesc={
                      typeof item.transcription_duration !== 'string'
                        ? item.transcription_duration
                        : t(item.transcription_duration)
                    }
                    type={item.type}
                  />
                  <CardBtnContainer btnLabel={t(item.upgradeTxt)} index={index} type={item.type} />
                  <CardPlanRight index={index} rightList={rightList} title={t(item.interestDesc)} />
                </div>
              );
            })}
          </div>
        </div>
        {lang === 'ja' && (
          <div className={styles.tax_tips}>
            <span className={styles.tax_tips_text}>※表示価格は全て税込価格です。</span>
          </div>
        )}
      </div>
    </CommonBlok>
  );
};
export default PricingCardContainer;
